import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { appendGraphQlMajorEntity, findAssociatedMajorEntity } from 'src/utils/utilPlanning';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiNoteShow = '/api/note/show/';

class DisplayNote extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      notFound: false,
      isModalPostCustomerOpen: false,
      entity: undefined,
      contactId: undefined,
      title: '____',
      text: '____',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiNoteShow;
      let graphQL = '{ note(id:' + paramsID + '){ id, title, text ' + appendGraphQlMajorEntity() + '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['note']) {
              this.setState({
                entity: data['data']['note'],
                title: data['data']['note']['title'],
                majorEntity: findAssociatedMajorEntity(data['data']['note']),
                text: data['data']['note']['text'],
              });
            } else {
              this.setState({ notFound: true });
            }
          }.bind(this)
        )
        .catch(
          function () {
            console.log('erreur fetch note entity');
          }.bind(this)
        );
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          appViewNavExtended={this.state.appViewNavExtended}
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          title='Fiche Note'
        />

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <InputUpdate
                inputType={'text'}
                inputLabel={'Titre'}
                inputValue={this.state.title}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'title')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              {this.state.majorEntity && (
                <div className='form-group'>
                  <label>{'Associé à ' + this.state.majorEntity.label + ':'}</label>
                  <Link to={this.state.majorEntity.linkTo + this.state.majorEntity.id}>
                    <input
                      name='majorEntity'
                      value={this.state.majorEntity.name}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.text}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>
        </div>
      </div>
    );
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { note(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiNoteShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['note'][fieldName] == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE note entity');
        }.bind(this)
      );
  }
}

export default withAuth(DisplayNote);
